import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const DISPLAY_CURRENCIES = ['EUR', 'GBP', 'USD'] as const;
export type DisplayCurrency = (typeof DISPLAY_CURRENCIES)[number];

export const CURRENCY_SYMBOLS: Record<DisplayCurrency, string> = {
  EUR: '€',
  GBP: '£',
  USD: '$',
};

interface CurrencyState {
  currency: DisplayCurrency;
  setCurrency: (currency: DisplayCurrency) => void;
}

/**
 * The header's display-currency preference.
 *
 * ⚠ Placeholder: the choice is stored but nothing converts money with it yet —
 * amounts still render in the currency the API returns them in. See
 * docs/PRODUCTION.md ("Header currency switcher").
 */
export const useDisplayCurrency = create<CurrencyState>()(
  persist(
    (set) => ({
      currency: 'EUR',
      setCurrency: (currency) => set({ currency }),
    }),
    { name: 'opengoal.platform.currency' },
  ),
);
